import type { UploadRow, UploadStatus } from "@/lib/datasetRegistry"

// Terminal upload states — an upload here is finished (success or not). Single
// source of truth, imported by both DatasetUploadsPage and computeVisibleUploads.
export const TERMINAL: UploadStatus[] = ["completed", "failed", "cancelled"]

/**
 * The rows shown in "Riwayat Upload" (history).
 *
 * In panel mode ("Progress Import"), an upload that is still **in flight**
 * (pending/processing) lives in that panel, so it is hidden from the history to
 * avoid showing it twice as an active row. But once it reaches a **terminal**
 * state (completed/failed/cancelled) it must appear in the history immediately —
 * without the user having to click "Upload lagi" or refresh.
 *
 * Bug B1 (#46): the previous logic excluded *every* tracked id, terminal ones
 * included, so a just-completed upload stayed trapped in the panel and the
 * history read "Belum ada upload." until "Upload lagi". Narrowing the exclusion
 * to in-flight ids fixes it; `liveUploads` already carries the terminal status
 * (updated over the cable), so the row renders correctly the moment it lands.
 */
export function computeVisibleUploads(
  liveUploads: UploadRow[],
  trackedUploads: ReadonlyArray<{ id: number; status: UploadStatus }>,
  panelMode: boolean,
): UploadRow[] {
  if (!panelMode) return liveUploads
  const inFlightTrackedIds = new Set(
    trackedUploads.filter((u) => !TERMINAL.includes(u.status)).map((u) => u.id),
  )
  return liveUploads.filter((u) => !inFlightTrackedIds.has(u.id))
}
